/* Company Confidential, Copyright (c) 2017 CRF Box, Ltd. All Rights Reserved. */

import { createStore, applyMiddleware, compose } from 'redux';
import createHistory from 'history/createBrowserHistory';
import { routerMiddleware } from 'react-router-redux';
import reducers from '../reducers/reducers';
import thunkMiddleware from 'redux-thunk';

const history = createHistory();
const middleware = applyMiddleware(routerMiddleware(history), thunkMiddleware);

export function makeStore() {
  return createStore(reducers, compose(middleware));
}

const store = makeStore();
export default store;
